export const AUTH_PARAMS = {
  authParams: {
    RequestHmacKey: 'sportcash',
    username: 'sportcash',
    secret: 'sportcash',
  },
};
